import React, { useState } from "react";
import axios from "axios";
import appConfig from "../config/app-config";

export default function useValidate() {
  const [response, SetResponse] = useState<any>();
  const [isValidating, setIsValidating] = useState(false);

  const validate = React.useCallback(async (values) => {
    try {
      setIsValidating(true);
      let resp = await axios.post(appConfig.baseUrl + "/v1/vouchers", values).then((res) => res.data);
      SetResponse(resp);
      setIsValidating(false);
    } catch (err) {
      setIsValidating(false);
      throw err;
    }
  }, []);

  return { validate, isValidating, response };
}
